import BaseAPI from "../api";

const path: string = "/edpex-project";

export type listType = {
  status?: string;
  created_id?: string;
  created_date?: string;
  modified_id?: string;
  modified_date?: number;
  type?: string;
  keyword?: number;
  limit?: number;
  page?: number;
};

export class edpexProjectAPI extends BaseAPI {
  static getEdpexProjectList(query: listType): Promise<any> {
    return this.api.get(`${path}/list`, {
      params: { ...query },
    });
  }

  static createEdpexProject(body: any): Promise<any> {
    return this.api.post(`${path}`, body);
  }

  static getEdpexProjectById(id: number): Promise<any> {
    return this.api.get(`${path}/${id}`);
  }

  static updateEdpeProject(id: number, body: any): Promise<any> {
    return this.api.patch(`${path}/${id}`, body);
  }

  static deleteEdpexProject(id: number): Promise<any> {
    return this.api.delete(`${path}/${id}`);
  }

  static uploadEdpexProjectFile(body: any): Promise<any> {
    return this.api.post(`${path}/upload-file`, body, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  static updateEdpeProjectComplete(id: number, body: any): Promise<any> {
    return this.api.patch(`${path}/${id}/complete`, body);
  }
}
